import Button from "@mui/material/Button";
import { grey, red } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React from "react";
import {
  format_DOW_ShortMonth_Date_Year,
  parsePreferredLeaveTime,
  parseRequestShiftTime,
} from "../util/dateTimeFormatter";
import { isLWOPTOWOPAllDayRequest, isLWOPTOWOPRequest } from "../util/timeOffRequestUtils";

const useStyles = makeStyles((theme) => ({
  table: {
    borderLeft: "none",
    borderRight: "none",
    borderBottom: "none",
    width: "80%",
    margin: "auto",
    "&.MuiDataGrid-root .MuiDataGrid-cell--textLeft": {
      paddingLeft: "16px",
    },
  },
  noTimeOffRequestMessage: {
    position: "relative",
    margin: "auto",
    top: "50px",
    color: theme.palette.secondary.swaGray3,
    fontSize: "28px",
  },
}));

const TimeOffRequestTable = ({ timeOffRequestsList, handleOnEditTimeOffRequest }) => {
  const classes = useStyles();

  const noTimeOffRequestMessage = () => {
    return <div className={classes.noTimeOffRequestMessage}>No Time Off Requested</div>;
  };

  const editTimeOffRequest = (row) => {
    return (
      <Button variant="outlined" color="primary" onClick={() => handleOnEditTimeOffRequest(row)}>
        Edit
      </Button>
    );
  };
  const renderDesktopEmployeeTimeOffTable = () => {
    const columns = [
      {
        field: "timeOffType",
        headerName: "Time Off Type",
        type: "string",
        flex: 0.2,
        sortable: false,
        renderCell: (params) => {
          const { row } = params;
          const color = row?.isExpired ? red[500] : grey[900];
          return <div style={{ color }}>{params.value}</div>;
        },
      },
      {
        field: "shiftDate",
        headerName: "Shift Date",
        type: "string",
        flex: 0.2,
        sortable: false,
        valueGetter: (params) => {
          return params.row;
        },
        valueFormatter: (params) => {
          return format_DOW_ShortMonth_Date_Year(params.value.shiftStartDateTime);
        },
        renderCell: (params) => {
          const val = format_DOW_ShortMonth_Date_Year(params.row.shiftStartDateTime);
          const { row } = params;
          const color = row?.isExpired ? red[500] : grey[900];
          return <div style={{ color }}>{val}</div>;
        },
      },
      {
        field: "shiftTime",
        headerName: "Shift Time",
        type: "string",
        flex: 0.2,
        sortable: false,
        valueGetter: (params) => {
          return params.row;
        },
        valueFormatter: (params) =>
          parseRequestShiftTime(params.value.shiftStartDateTime, params.value.shiftEndDateTime),
        renderCell: (params) => {
          const val = parseRequestShiftTime(params.row.shiftStartDateTime, params.row.shiftEndDateTime);
          const { row } = params;
          const color = row?.isExpired ? red[500] : grey[900];
          return <div style={{ color }}>{val}</div>;
        },
      },
      {
        field: "preferredWOPLeaveTime",
        headerName: "Preferred Leave Time",
        flex: 0.2,
        sortable: false,
        valueGetter: (params) => {
          return params.row;
        },
        valueFormatter: (params) => {
          if (!isLWOPTOWOPRequest(params.value.timeOffType)) return "";
          if (isLWOPTOWOPAllDayRequest(params.value.timeOffType))
            return parseRequestShiftTime(params.value.shiftStartDateTime, params.value.shiftEndDateTime);
          return params.value.wopASAP
            ? "ASAP"
            : parsePreferredLeaveTime(params.value.preferredWOPStartTime, params.value.preferredWOPEndTime);
        },
        renderCell: (params) => {
          if (!isLWOPTOWOPRequest(params.row.timeOffType)) return "";
          let val = "";
          if (isLWOPTOWOPAllDayRequest(params.row.timeOffType))
            val = parseRequestShiftTime(params.row.shiftStartDateTime, params.row.shiftEndDateTime);
          else
            val = params.row.wopASAP
              ? "ASAP"
              : parsePreferredLeaveTime(params.row.preferredWOPStartTime, params.row.preferredWOPEndTime);
          const { row } = params;
          const color = row?.isExpired ? red[500] : grey[900];
          return <div style={{ color }}>{val}</div>;
        },
        type: "string",
      },
      {
        field: " ",
        headerName: " ",
        flex: 0.14,
        sortable: false,
        renderCell: (params) => {
          return editTimeOffRequest(params.row);
        },
      },
    ];

    return (
      <>
        <DataGridPro
          className={classes.table}
          rows={timeOffRequestsList}
          getRowId={(row) => row.id}
          columns={columns}
          disableColumnMenu={true}
          components={{
            NoRowsOverlay: noTimeOffRequestMessage,
          }}
          autoHeight={true}
        />
      </>
    );
  };

  return <div>{renderDesktopEmployeeTimeOffTable()}</div>;
};

TimeOffRequestTable.propTypes = {};
export default TimeOffRequestTable;
